import { PersonAdd } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import { Fragment, useState } from 'react';

import { processFilestackUrlSrcSet } from '@jebel/utils';

import { InviteMemberModal } from 'shared/components/dialogs';
import { SchoolAvatar } from 'shared/components/symbols';
import { NotificationsPopover } from 'shared/features/notifications/components';
import { useCanAddMembers, useCurrentUser, useSchoolConfiguration } from 'shared/hooks';

import { HeaderNavigationPopover } from '../HeaderNavigationPopover';
import {
  Buttons,
  Container,
  IconButton,
  SchoolContainer,
  SchoolName,
} from './HeaderNavigationMobile.styles';

interface Props {
  isAdminRoute?: boolean;
}

const DEFAULT_AVATAR_SIZE = 40;

export function HeaderNavigationMobile(props: Props) {
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  const { configuration } = useSchoolConfiguration();
  const { user, loading } = useCurrentUser();

  const schoolName = configuration?.name ?? 'School';
  const userAvatar = user?.avatar?.downloadUrl as string;

  const canInviteMembers = useCanAddMembers();

  const onInviteModalOpen = () => {
    setInviteModalOpen(true);
  };

  const onInviteModalClose = () => {
    setInviteModalOpen(false);
  };

  return (
    <Container>
      <SchoolContainer>
        <SchoolAvatar />
        <SchoolName>{schoolName}</SchoolName>
      </SchoolContainer>

      <Buttons>
        {canInviteMembers && (
          <Fragment>
            <IconButton onClick={onInviteModalOpen}>
              <PersonAdd color="inherit" />
            </IconButton>

            <InviteMemberModal open={inviteModalOpen} onClose={onInviteModalClose} />
          </Fragment>
        )}

        <NotificationsPopover />

        <HeaderNavigationPopover
          user={user}
          userLoading={loading}
          isAdminRoute={props.isAdminRoute}
          target={
            <Avatar
              variant="circular"
              src={userAvatar}
              srcSet={processFilestackUrlSrcSet(userAvatar, {
                compress: true,
                resize: { width: DEFAULT_AVATAR_SIZE, height: DEFAULT_AVATAR_SIZE, fit: 'crop' },
              })}
            />
          }
        />
      </Buttons>
    </Container>
  );
}
